import {
  ButtonTypeColors,
  ButtonTypes,
  ButtonSizeEnums,
  ButtonsType,
} from '@/core/enums/buttons.enums';

export const useButtonCustom = () => {
  return {
    ButtonTypeColors,
    ButtonTypes,
    ButtonSizeEnums,
    ButtonsType,
  };
};
